/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Card, Button, Form, Row, Col } from 'react-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Pagination from '../Features/Pagination/Pagination';
import moment from 'moment';

export default function CheckupReport() {
  const [checkups, setCheckups] = useState([]);
  const [filteredCheckups, setFilteredCheckups] = useState([]);
  const [filters, setFilters] = useState({
    status: '',
    patientName: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [appointmentsPerPage] = useState(5);

  useEffect(() => {
    axios.get('https://project01-n0pn.onrender.com/api/checkup/getallcheckups')
      .then((response) => {
        setCheckups(response.data);
        setFilteredCheckups(response.data);
      })
      .catch((error) => {
        console.error('Error fetching checkup data:', error);
      });
  }, []);

  // Calculate the number of pages
  const totalPages = Math.ceil(filteredCheckups.length / appointmentsPerPage);

  // Get current appointments data for the page
  const indexOfLastAppointment = currentPage * appointmentsPerPage;
  const indexOfFirstAppointment = indexOfLastAppointment - appointmentsPerPage;
  const currentAppointments = filteredCheckups.slice(indexOfFirstAppointment, indexOfLastAppointment);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const downloadPDF = () => {
    const input = document.getElementById('checkup-report');
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('checkup_report.pdf');
      })
      .catch((error) => {
        console.error('Error generating PDF:', error);
      });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  const applyFilters = () => {
    let filteredData = checkups;

    if (filters.patient_nic) {
      filteredData = filteredData.filter(checkup => checkup.patient_nic.toLowerCase().includes(filters.patient_nic.toLowerCase()));
    }

    if (filters.doctor_user_name) {
      filteredData = filteredData.filter(checkup => checkup.doctor_user_name.toLowerCase().includes(filters.doctor_user_name.toLowerCase()));
    }

    setFilteredCheckups(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [filters]);

  return (
    <Card className='card-container'>
      <Card.Body>
        <Card.Title className='header'>Checkup Report</Card.Title>
        <Form>
          <Row>
            <Col>
          <Form.Group controlId="filterPatientNIC">
            <Form.Control
              type="text"
              placeholder="Enter patient nic"
              name="patient_nic"
              value={filters.patient_nic}
              onChange={handleFilterChange}
            />
          </Form.Group>
          </Col>
          <Col>
          <Form.Group controlId="filterDoctorUserName">
            <Form.Control
              type="text"
              placeholder="Enter doctor user name"
              name="doctor_user_name"
              value={filters.doctor_user_name}
              onChange={handleFilterChange}
            />
          </Form.Group>
          </Col>
          </Row>
        </Form>
        <Button variant="primary" onClick={downloadPDF} className="mt-3">Download as PDF</Button>
        <div id="checkup-report" className="mt-3">
          <Table responsive className="table">
            <thead>
              <tr>
              <th>Patient NIC</th>
            <th>Doctor Username</th>
            <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {currentAppointments.map((checkup) => (
                <tr key={checkup.checkup_id}>
                  <td>{checkup.patient_nic}</td>
                  <td>{checkup.doctor_user_name}</td>
                  <td>{moment(checkup.createdAtCheckup).format("MMMM Do YYYY, h:mm:ss a")}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
        </div>
      </Card.Body>
    </Card>
  );
}